module.exports = __webpack_public_path__ + "fonts/Sarabun-MediumItalic.f023aeb3.ttf";